"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var OutfallSafari_exports = {};
__export(OutfallSafari_exports, {
  OutfallSafari: () => OutfallSafari
});
module.exports = __toCommonJS(OutfallSafari_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_core = require("../../core/index.js");
function eaScoreBuckets(m) {
  return [
    (0, import_topo_map.rangeBucket)(m * 0, m * 2, import_topo_map.marker.quality(10 / 10), String(m * 0)),
    (0, import_topo_map.rangeBucket)(m * 2, m * 4, import_topo_map.marker.quality(8 / 10), String(m * 2)),
    (0, import_topo_map.rangeBucket)(m * 4, m * 6, import_topo_map.marker.quality(6 / 10), String(m * 4)),
    (0, import_topo_map.rangeBucket)(m * 6, m * 10, import_topo_map.marker.quality(4 / 10), String(m * 6)),
    (0, import_topo_map.rangeBucket)(m * 10, null, import_topo_map.marker.quality(0 / 10), String(m * 10)),
    (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
  ];
}
const OutfallSafari = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("OutfallSafari"),
  title: "Outfall Safari",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("OutfallSafari"),
      title: "Outfall Safari",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("OutfallSafari"),
        attribution: []
      }),
      defaultAttribute: "overallScore",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.surveyorAttr)(),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "activity",
              label: "Activity",
              enum: import_inventory_enums.OutfallSafariActivityEnum,
              markers: {
                [import_inventory_enums.OutfallSafariActivityEnum.Start]: import_topo_map.marker.fromColor("limegreen"),
                [import_inventory_enums.OutfallSafariActivityEnum.Outfall]: import_topo_map.marker.fromColor("cyan"),
                [import_inventory_enums.OutfallSafariActivityEnum.Inaccessible]: import_topo_map.marker.fromColor("magenta"),
                [import_inventory_enums.OutfallSafariActivityEnum.End]: import_topo_map.marker.fromColor("orange")
              }
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Outfall",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "outfallBank",
              label: "Outfall Bank",
              enum: import_inventory_enums.OutfallSafariBankEnum,
              markers: {
                [import_inventory_enums.OutfallSafariBankEnum.Left]: import_topo_map.marker.fromColor("orange"),
                [import_inventory_enums.OutfallSafariBankEnum.Right]: import_topo_map.marker.fromColor("cyan")
              }
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "flowOfDischarge",
              label: "Flow of Discharge",
              enum: import_inventory_enums.OutfallSafariFlowOfDischargeEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "visualImpact",
              label: "Visual Impact",
              enum: import_inventory_enums.OutfallSafariVisualImpactEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "aesthetics",
              label: "Aesthetics",
              enum: import_inventory_enums.OutfallSafariAestheticsEnum
            }),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs of Outfalls")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Environment Agency Scores",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "visualImpactScore",
              label: "Visual Impact Score",
              buckets: eaScoreBuckets(1),
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "aestheticsScore",
              label: "Aesthetics Score",
              buckets: eaScoreBuckets(1),
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "overallScore",
              label: "Overall Score",
              buckets: eaScoreBuckets(2),
              decimalPlaces: 0
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  OutfallSafari
});
//# sourceMappingURL=OutfallSafari.js.map
